import { createSlice } from '@reduxjs/toolkit'

let Slices = [];
let dataReducers = {};
let dataActions  = {};

/*---------------------------------------------------------------*/

export const gdSlice = createSlice({
    name: 'gd',
    initialState: false,
    reducers: {
        setGd: (state, action) => action.payload,
    },
});

Slices.push(gdSlice);

/*---------------------------------------------------------------*/

export const userSlice = createSlice({
    name: 'userData',
    initialState: false,
    reducers: {
        setUser: (state, action) => action.payload,
    },
});

Slices.push(userSlice);

/*---------------------------------------------------------------*/

export const metaTagsSlice = createSlice({
    name: 'metaTags',
    initialState: false,
    reducers: {
        setMetaTags: (state, action) => action.payload,
    },
});

Slices.push(metaTagsSlice);

/*---------------------------------------------------------------*/

export const insurancePageSlice = createSlice({
    name: 'insurancePage',
    initialState: false,
    reducers: {
        setInsurancePage: (state, action) => action.payload,
    },
});

Slices.push(insurancePageSlice);

/*---------------------------------------------------------------*/

// Build export objects
for (const Slice of Slices) {
    let reducer  = { [Slice.name]: Slice.reducer };
    dataActions  = { ...dataActions, ...Slice.actions };
    dataReducers = { ...dataReducers, ...reducer };
}

export { dataActions };
export { dataReducers };
